import { BillingAddress, getSchema } from "./billing_address";

const BillingAddressForm = {
  Form: BillingAddress,
  getSchema,
};

export default BillingAddressForm;
